import { render, staticRenderFns } from "./VeColumnConfigDialog.vue?vue&type=template&id=6f156719&scoped=true&"
import script from "./VeColumnConfigDialog.vue?vue&type=script&lang=js&"
export * from "./VeColumnConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./VeColumnConfigDialog.vue?vue&type=style&index=0&id=6f156719&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f156719",
  null
  
)

export default component.exports